// DR9/DR13 (birim varyantı) — portal hücre editörünün İÇİNDE amber satır: müşteri yazarken
// danışman göstergenin birimini değiştirmişse (409 KPI_UNIT_CHANGED) değer kaydedilmez; satır eski
// ve yeni birimi + yazılan değeri söyler, taslak editörde kalır (otomatik yeniden gönderim yok).
// Grid'de kapalı hücrede yalnız amber nokta (56 px portal satırı korunur — KpiGridRow).
// Kopya tek kaynak `KPI_COPY.portal.unitChanged` (müşteri yüzeyi kuralı: "AI/üretim/danışman notu" yok).

import type { KpiResolvedCell, KpiResolvedIndicator } from "@mahir/shared";
import type { PortalUnitChanged } from "../../lib/kpi-unit-changed";
import { KPI_UNIT_COPY } from "../../lib/kpi-unit-copy";
import { formatKpiCell, KPI_COPY } from "../../lib/kpi-ui";

export function KpiCellUnitChangedNotice(p: {
  from: string | null;
  to: string | null;
  typed: string;
}): JSX.Element {
  const u = (x: string | null): string => (x && x.trim() !== "" ? x : KPI_UNIT_COPY.unitless);
  return (
    <div
      role="alert"
      data-testid="kpi-unit-changed"
      className="mb-2 px-2 py-1.5 rounded-lg"
      style={{
        fontSize: "0.875rem",
        fontFamily: "var(--font-sans)",
        background: "var(--color-warning-bg)",
        border: "1px solid var(--color-warning-border)",
        color: "var(--color-warning-text)",
      }}
    >
      {KPI_COPY.portal.unitChanged(u(p.from), u(p.to), p.typed)}
    </div>
  );
}

/** Editörün ilk taslağı: yazarak açılış (ilk tuş) > birim değişti taslağı > hücrenin değeri. */
export function initialEditorRaw(a: {
  initialRaw: string | undefined;
  unitChanged: PortalUnitChanged | undefined;
  cell: KpiResolvedCell | undefined;
  indicator: Pick<KpiResolvedIndicator, "valueType">;
}): string {
  if (a.initialRaw !== undefined && a.initialRaw !== "") return a.initialRaw;
  if (a.unitChanged && a.unitChanged.draft !== "") return a.unitChanged.draft;
  const c = a.cell;
  if (c?.status === "filled" && typeof c.value === "number") {
    return formatKpiCell(c, { percent: a.indicator.valueType === "percent" }).text.replace(
      /^%/,
      "",
    );
  }
  return c?.text ?? "";
}
